import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './icon-gallery-block.scss.js';

class IconGalleryBlock extends s {
    constructor() {
        super(...arguments);
        this.additionalClasses = '';
    }
    render() {
        return $ `<div class="grid-container ${this.additionalClasses}"><slot></slot></div>`;
    }
}
IconGalleryBlock.styles = css_248z;
__decorate([
    e({ type: String })
], IconGalleryBlock.prototype, "additionalClasses", void 0);
customElements.define('icon-gallery-block', IconGalleryBlock);

export { IconGalleryBlock };
